var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('deliver-apply',{directives:[{name:"show",rawName:"v-show",value:(_vm.active === 'query'),expression:"active === 'query'"}],on:{"changeActive":_vm.changeActive}}),_vm._v(" "),(_vm.active === 'toGoods')?_c('to-goods',{attrs:{"row-data":_vm.row},on:{"back":_vm.back}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b0ea5e4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/apply-for-manage/business-processing/deliverApply.vue
// module id = null
// module chunks = 